 
 import React, { useState, useEffect } from "react";

import { ToastContainer, toast } from "react-toastify";  // Importer les éléments nécessaires
import "react-toastify/dist/ReactToastify.css"; // Importer le CSS de react-toastify
import "./App.css";
import CommandeModal from "./components/CommandeModal";
import Presentation from "./components/Presentation";
import Contact from "./components/Contact";
import Celeste from "./components/Celeste";
import YouTubeGallery from "./components/YoutubeGallery";
import { SwiperCarousel } from "./components/CarouselOutils";
import { usePanier } from "./PanierContext";
import { useNavigate } from "react-router-dom";

import angoisse from "./img/ANGOISSE.jpeg";
import temporalite from "./img/PARCOURS.jpeg";
import cigarette from "./img/CIGARETTE.jpeg";
import diagnostic from "./img/DIAGNOSTIC.jpeg";
import plafonnement from "./img/PLAFONNEMENT.jpeg";
import psychiatrie from "./img/PSYCHIATRIE.jpeg";
import psychopathe from "./img/PSYCHOPATHE.jpeg";
import traitement from "./img/TRAITEMENT.jpeg";
import suicide from "./img/SUICIDE.jpg";

const images = [angoisse,temporalite,cigarette,diagnostic,plafonnement,psychiatrie,psychopathe,traitement,suicide]


const HomePage: React.FC = () => {
  const navigate = useNavigate();

 return (
    <>
      <Celeste></Celeste>
      <SwiperCarousel images={images}></SwiperCarousel>

      <Presentation></Presentation>

      <div style={{textAlign:"center",margin:"40px"}}>
        <button
          className="retour-outil-btn"
          style={{paddingLeft:"70px",paddingRight:"70px"}}
          onClick={() => navigate("/outils")}
        >🛠️ Voir la boutique</button>
     </div> 

      <Contact></Contact>

      <ToastContainer />

      <YouTubeGallery></YouTubeGallery>
        <br/>
        <br/>
        <br/>
        <br/>
    </>
)}


export default HomePage;
